import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DemoRecipeDetail } from '../../../mocks/data/demoRecipeTypes';

const DemoProcessChecksTab = ({ detail }: { detail: DemoRecipeDetail }) => {
  const { t } = useTranslation('recipeV2');
  const controls = detail.criticalControls ?? [];

  if (controls.length === 0) return <Typography color="text.secondary">{t('demoAdvanced.noControls')}</Typography>;

  return (
    <Stack spacing={2}>
      <Typography variant="textLG"
        fontWeight={600}>{t('demoAdvanced.controlsTitle')}</Typography>
      <Typography color="text.secondary">{t('demoAdvanced.controlsIntro')}</Typography>
      {controls.map((control) => (
        <Paper key={control}
          variant="outlined"
          sx={{ p: 2 }}>
          <Typography variant="textSM">{control}</Typography>
        </Paper>
      ))}
    </Stack>
  );
};

export default DemoProcessChecksTab;
